import store from "../../store/store";

export const componentKey = "TASK_SLICE";

const { actions } = store.reducerManager.add({
  key: componentKey,
  addedReducers: {
    setCloseAddTaskDialog: (state, action) => {
      state.closeAddTaskDialog = action.payload;
    },
    setTaskTaskListData: (state, action) => {
      state.taskListData = action.payload;
    },
    setCloseCreateGroupDialog: (state, action) => {
      state.closeCreateGroupDialog = action.payload;
    },
    setGroupListData: (state, action) => {
      state.groupListData = action.payload;
    },
    setAssignToListData: (state, action) => {
      state.assignToListData = action.payload;
    },
    setTaskTypeListData: (state, action) => {
      state.taskTypeListData = action.payload;
    },
  },
  initialReducerState: {
    closeAddTaskDialog: false,
    taskListData: {},
    closeCreateGroupDialog: false,
    groupListData: {},
    assignToListData: {},
    taskTypeListData: [],
  },
});

export const { setCloseAddTaskDialog, setTaskTaskListData, setCloseCreateGroupDialog, setGroupListData, setAssignToListData, setTaskTypeListData } = actions;
